import React from 'react';
import { connect } from 'react-redux';
import Mixpanel from 'helpers/Mixpanel.js';
import Tag from 'components/Global/Tag/Tag.jsx';
import ListFilter from '@bit/knotchinc.web-react-components.list-filter';

class TagFilter extends React.Component {
  itemFiltering(item) {
    const { type, setFilters, selectedItems } = this.props;
    let newCategories;
    if (selectedItems.includes(item.value)) {
      Mixpanel.track('removed keyword filter', { filter: item.value });
      newCategories = selectedItems.filter(selectedItem => selectedItem !== item.value);
    } else {
      Mixpanel.track('added keyword filter', { filter: item.value });
      newCategories = selectedItems.concat(item.value);
    }
    setFilters({ [type]: newCategories, pageNum: 1 }, this.props.filterAction);
  }

  render() {
    const { title, type, items, fetch, selectedItems, listAction, searchBy } = this.props;
    return (
      <ListFilter
        showSearch
        title={title || type}
        fetch={clear => fetch(clear)}
        listStore={items}
        filterCondition={item => selectedItems.indexOf(item.value) === -1}
        filterAction={listAction}
        searchBy={searchBy}
      >
        <Tag
          onClick={item => this.itemFiltering(item)}
        />
      </ListFilter>);
  }
}

const mapDispatchToProps = dispatch => ({
  setFilters: (filters, type) => dispatch({ type, filters }),
});

TagFilter.defaultProps = {
  selectedItems: [],
  searchBy: 'value',
};

export default connect(null, mapDispatchToProps)(TagFilter);
